import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import { useWebsiteSettings } from 'client/store'
import { getWebsiteStylesTypographyParagraph } from 'src/editor/store/website-settings/website-settings-selector'

export const useHeadingLetterSpacing = ({
  letterSpacing,
  mobileLetterSpacing,
}: {
  letterSpacing?: number
  mobileLetterSpacing?: number
}) => {
  const { isMobile } = useDeviceModeContext()
  const {
    letterSpacing: globalLetterSpacing,
    mobileLetterSpacing: globalMobileLetterSpacing,
  } = useWebsiteSettings(getWebsiteStylesTypographyParagraph) || {}

  const calculatedLetterSpacing = isMobile
    ? mobileLetterSpacing || globalMobileLetterSpacing
    : letterSpacing || globalLetterSpacing

  return {
    calculatedLetterSpacing,
    globalLetterSpacing,
    globalMobileLetterSpacing,
  }
}
